module.exports = __webpack_public_path__ + "img/Eva.73cec6a3.jpg";